
import { supabase } from '@/integrations/supabase/client';
import { SupermarketPrice, CreateSupermarketPriceInput, SupermarketPriceFilters } from '@/types/database/supermarket-prices';

export const supermarketPriceService = {
  async getAll(filters: SupermarketPriceFilters = {}) {
    let query = supabase
      .from('supermarket_prices')
      .select('*')
      .order('date', { ascending: false });

    if (filters.product_name) {
      // Use exact match instead of partial match
      query = query.eq('product_name', filters.product_name);
    }

    if (filters.location) {
      query = query.eq('location', filters.location);
    }

    if (filters.date_from) {
      query = query.gte('date', filters.date_from);
    }

    if (filters.date_to) {
      query = query.lte('date', filters.date_to);
    }

    const { data, error } = await query.limit(10000);

    if (error) {
      console.error('Error fetching supermarket prices:', error);
      throw error;
    }

    return data || [];
  },

  async create(input: CreateSupermarketPriceInput) {
    const { data, error } = await supabase
      .from('supermarket_prices')
      .insert([input])
      .select()
      .single();

    if (error) {
      console.error('Error creating supermarket price:', error);
      throw error;
    }

    return data;
  },

  async getUniqueProducts() {
    const { data, error } = await supabase
      .from('supermarket_prices')
      .select('product_name')
      .neq('product_name', null);

    if (error) {
      console.error('Error fetching unique products:', error);
      throw error;
    }

    const uniqueProducts = [...new Set(data?.map(item => item.product_name) || [])];
    return uniqueProducts;
  }
};
